import React, { useContext } from 'react';
import { StringColumn, CustomColumn } from 'baseui/data-table';
import { Button } from 'baseui/button';
import { useStyletron } from 'baseui';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';

import { CustomDateColumn, EMPTY_STRING, AppContext } from 'commons-ui';
import downloadImg from 'commons-ui/src/assets/misc/download.png';

export const COL_NAMES = {
	state: 'state',
	refundedAt: 'refundedAt',
	refundedBy: 'refundedBy',
	uploadedAt: 'uploadedAt',
	uploadedBy: 'uploadedBy',
	csvName: 'csvName',
	description: 'description',
	gameName: 'gameName',
	uplodedFile: 'csvUrl',
	outputCsvUrl: 'outputCsvUrl',
	isBulkRefundV2: 'isBulkRefundV2',
	statusWiseCounts: 'statusWiseCounts',
	totalCount: 'totalCount'
};

export const columnConfigs = [
	StringColumn({
		title: 'Game Name',
		mapDataToValue: (data: any) => data[COL_NAMES.gameName] || EMPTY_STRING
	}),
	StringColumn({
		title: 'CSV Name',
		mapDataToValue: (data: any) => data[COL_NAMES.csvName] || EMPTY_STRING
	}),
	CustomColumn({
		title: 'Description',
		minWidth: 300,
		maxWidth: 400,
		mapDataToValue: (data: any) => data[COL_NAMES.description] || EMPTY_STRING,
		renderCell: (params: any) => {
			const { value } = params;
			let descriptionCompress = '';
			if (value.length > 50) {
				descriptionCompress = `${value.substr(0, 50)}...`;
			} else {
				descriptionCompress = value;
			}
			return <div title={value}>{descriptionCompress}</div>;
		}
	}),
	StringColumn({
		title: 'State',
		mapDataToValue: (data: any) => data[COL_NAMES.state] || EMPTY_STRING
	}),
	CustomColumn({
		title: 'Status Wise Counts',
		minWidth: 300,
		maxWidth: 400,
		mapDataToValue: (data: any) => {
			const statusWiseCounts = data[COL_NAMES.statusWiseCounts];
			const total = data[COL_NAMES.totalCount];
			return statusWiseCounts ? { counts: statusWiseCounts, total } : EMPTY_STRING;
		},
		renderCell: (params: any) => {
			const { value }: { value: { counts: { status: string; count: number }[]; total: number } } = params;
			if (!Array.isArray(value?.counts)) {
				return <div>No data available</div>;
			}
			let valueString = value.counts
				.map((item: { status: string; count: number }) => `${item.status}: ${item.count}`)
				.join(', ');
			const totalString = `Total: ${value.total}`;
			valueString += `, ${totalString}`;
			return <div>{valueString}</div>;
		}
	}),
	StringColumn({
		title: 'Refunded By',
		minWidth: 150,
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.refundedBy] || EMPTY_STRING
	}),
	CustomDateColumn({
		title: 'Refunded At',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.refundedAt
	}),
	StringColumn({
		title: 'Uploaded By',
		mapDataToValue: (data: any) => data[COL_NAMES.uploadedBy] || EMPTY_STRING
	}),
	CustomDateColumn({
		title: 'Uploaded At',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.uploadedAt
	}),
	CustomColumn({
		title: 'Uploaded File',
		minWidth: 100,
		maxWidth: 100,
		mapDataToValue: (data: string) => _get(data, COL_NAMES.uplodedFile),
		renderCell: ({ value }: { value: string }) => {
			const { showAlert } = useContext(AppContext);
			const [css] = useStyletron();

			const handleClick = () => {
				if (!_isEmpty(value)) {
					window.open(value, '_self');
					showAlert('Uploaded file downloaded successfully!');
				} else {
					showAlert('Uploaded file is not available!', { type: 'error' });
				}
			};

			return (
				<Button onClick={handleClick} size='mini' kind='tertiary'>
					<img className={css({ height: '20px', width: '20px' })} src={downloadImg} alt='download' />
				</Button>
			);
		}
	}),
	CustomColumn({
		title: 'Response',
		minWidth: 100,
		maxWidth: 100,
		mapDataToValue: (data: string) => _get(data, COL_NAMES.outputCsvUrl),
		renderCell: ({ value }: { value: string }) => {
			const { showAlert } = useContext(AppContext);
			const [css] = useStyletron();

			const handleClick = () => {
				if (!_isEmpty(value)) {
					window.open(value, '_self');
					showAlert('Response file downloaded successfully!');
				} else {
					showAlert('Response file is not available!', { type: 'error' });
				}
			};

			return (
				<Button onClick={handleClick} size='mini' kind='tertiary'>
					<img className={css({ height: '20px', width: '20px' })} src={downloadImg} alt='download' />
				</Button>
			);
		}
	})
];
